import { render, staticRenderFns } from "./rate-icon.vue?vue&type=template&id=f3beea66&"
import script from "./rate-icon.vue?vue&type=script&lang=js&"
export * from "./rate-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports